"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dependencies = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SubjectDependency = _interopRequireDefault(require("customer-data-sidebar/dependency/SubjectDependency"));

var _PropertiesStore = _interopRequireDefault(require("crm_data/properties/PropertiesStore"));

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _PropertyModel = require("customer-data-objects/model/PropertyModel");

var _get = _interopRequireDefault(require("transmute/get"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var dependencies = {
  subject: _SubjectDependency.default,
  favorites: {
    propTypes: {
      objectType: _propTypes.default.oneOf([_ObjectTypes.COMPANY, _ObjectTypes.CONTACT, _ObjectTypes.DEAL, _ObjectTypes.TICKET]).isRequired,
      apiData: _propTypes.default.shape({
        propertyNames: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired
      })
    },
    stores: [_PropertiesStore.default],
    deref: function deref(_ref) {
      var objectType = _ref.objectType,
          apiData = _ref.apiData;

      if (!objectType || !apiData) {
        return _LoadingStatus.LOADING;
      }

      var propertyNames = (0, _get.default)('propertyNames', apiData);

      if (!propertyNames) {
        return _LoadingStatus.LOADING;
      }

      var propertiesForType = _PropertiesStore.default.get(objectType);

      if (!propertiesForType) {
        return _LoadingStatus.LOADING;
      }

      return propertyNames.map(function (propertyName) {
        return propertiesForType.get(propertyName);
      }).filter(function (property) {
        return (0, _identity.default)(property) && (0, _PropertyModel.isVisibleProperty)(property);
      });
    }
  }
};
exports.dependencies = dependencies;